const EXTRA_PERCENTAGE = 0.1;
const PERIOD_YEARS = 2;
const PAYMENT_FREQUENCY = {
    "monthly": 12,
    "biweekly": 26
};

function calculateSavings(amount, freq) {
    return amount * PERIOD_YEARS * PAYMENT_FREQUENCY[freq];
}

export {
    calculateSavings,
    EXTRA_PERCENTAGE as extraPercentage
};